export default {"src":"/_next/static/media/VarDelivery.c35d4daf.svg","height":418,"width":418,"blurWidth":0,"blurHeight":0};